import { axios } from '@/utils/request'

export function getAllDeadlineConfig (parameter = {}) {
  return axios({
    url: '/normalConfig/getAllDeadlineConfig',
    method: 'post',
    data: parameter
  })
}
